module.exports = __webpack_public_path__ + "static/media/trainer6.0bbef298.jpg";